
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Courses from "./courses"
import Hurdle from "./hurdle"
import Testimonial from "./testimonial"
import IvanoWorks from "./ivanoWorks"
import {Link} from "react-router-dom"; 
import $ from 'jquery';

import Banner from "./banner"

export default class Home extends Component {
    render() {

    return (

      <div className="main-wrapper home-wrapper">
        <Header></Header>
        <div className="main-content px-0">   
          <Banner></Banner>
          <Courses></Courses>
          <Hurdle></Hurdle>
          <IvanoWorks></IvanoWorks>
          <Testimonial></Testimonial>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/home/home.jsx